import clsx from 'clsx'
import React from 'react'

import CheckSVG from '@Assets/SVG/Check'
import PlusSVG from '@Assets/SVG/Plus'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { Chip } from '@Components/Chips/Chip/Chip'
import { Wordbook } from '@Components/Wordbook'
import { ProductItem } from '@Domains/Product/Components/ProductItem'
import { AddToCartPromptSuccessTacticFragmentFragment } from '@Generated/graphql'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { createAddToCartTacticFromOffer } from '@Shared/Utilities/AddToCartHelper'

import styles from './MatchingVariant.module.scss'

type Tactic = Extract<AddToCartPromptSuccessTacticFragmentFragment, { __typename: 'TacticMatchingVariant' }>

export const MatchingVariantTactic = ({
  parentLineItemID,
  tactic,
}: {
  parentLineItemID: string
  tactic: Tactic
}) => {
  const [addedToCart, setAddedToCart] = React.useState<boolean>(false)
  const campaignOverrideV1 = useSplitTest('campaign_override_v1', 'b')

  if (!tactic.product || !tactic.productID) {
    return null
  }

  return (
    <div className={clsx(styles.addToCartPromptSuccess, 'fullwidth', campaignOverrideV1 && styles.campaignOverride)}>
      {campaignOverrideV1 && <Chip color="end_season_sale_small" />}
      <div className={styles.matchingVariantTitle}><Wordbook wordbook={tactic.title} /></div>
      <ProductItem
        action={(
          <BuyButtonV2
            className={clsx(styles.AddToCartProduct, addedToCart && styles.success)}
            color="black"
            disabled={addedToCart}
            onSuccess={() => setAddedToCart(true)}
            productID={tactic.productID}
            products={[
              {
                quantity: 1,
                variantID: '',
                productID: tactic.productID,
                ...tactic.offer && tactic.offer.price && {
                  parentLineItemID,
                  tactic: createAddToCartTacticFromOffer(tactic.offer),
                },
              },
            ]}
            sourceID="matching_variant_products"
            useCache={false}
            withoutSuccessPrompt
          >
            {!addedToCart && <PlusSVG />}
            {addedToCart && <CheckSVG />}
          </BuyButtonV2>
        )}
        analytics={{ source_id: 'add_to_cart_bought_together' }}
        className={styles.matchingVariantProduct}
        content={tactic.product.name}
        discount={tactic.offer?.price?.discount?.format || tactic.product.masterVariant?.price?.discount?.format || undefined}
        imageUrl={tactic.product.primaryAsset?.url || ''}
        price={tactic.offer?.price?.format || tactic.product.masterVariant?.price?.format || ''}
      />
    </div>
  )
}
